module.exports = __webpack_public_path__ + "img/430a.67aad8f4.png";